import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

export default function AdminRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading || user === null) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-[#f8f9fa]" data-testid="admin-route-loader">
        <div className="text-slate-500 text-sm tracking-wider uppercase">Chargement…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (user.role !== "admin" && user.role !== "superadmin") return <Navigate to="/dashboard" replace />;
  return children;
}
